import TimeSplitter from "src/utils/time-splitter";

const causalValueFormatter = ({ units, value, isSlider }) => {
    if (!units && !value) return null;
    if (units && units.type === "duration") {
        if (isSlider) {
            const formattedDuration = TimeSplitter(Math.abs(value), "minified");
            return formattedDuration;
        }
        const formattedDuration = TimeSplitter(Math.abs(value), "stage-duration");
        return formattedDuration;
    }
    if (units && units.type === "numeric") {
        return value.toFixed(2);
    }
    if (units && units.type === "unitless") {
        return value.toFixed(2);
    }
    return null;
};

export default causalValueFormatter;
